import { IAzureActiveDirectory } from './environment.model';

export const azureActiveDirectory: IAzureActiveDirectory = {
  authority: 'https://login.microsoftonline.com/3f9cd7a0-127a-4ed4-bf06-2f830d5616b7',
  clientId: 'bac1edeb-ec0c-4759-b086-a5e5acf8e3c8'
};